import { createContext, useContext } from 'react';
import { DEFAULT_LOCALE, type Locale } from './locale.ts';
import type { Digits } from './format/digits.ts';
import type { Calendar } from './format/date.ts';

export interface LocalePrefs {
  locale: Locale;
  /** Persian digits (arabext) vs Latin. Default: fa → 'fa', en → 'latn'. */
  digits: Digits;
  /** Jalali vs Gregorian. Default: fa → 'persian', en → 'gregory'. */
  calendar: Calendar;
  timeZone: string;
}

export const defaultPrefs = (locale: Locale = DEFAULT_LOCALE): LocalePrefs => ({
  locale,
  digits: locale === 'fa' ? 'fa' : 'latn',
  calendar: locale === 'fa' ? 'persian' : 'gregory',
  timeZone: 'Asia/Tehran',
});

export const PrefsCtx = createContext<LocalePrefs>(defaultPrefs());
export const useLocalePrefs = () => useContext(PrefsCtx);
